module.exports = __webpack_public_path__ + "img/logo-mobile.64aa3be8.svg";